import { getDate, setDate, format } from 'date-fns';

const unavailableDraftDates = [29, 30, 31];

export default function CalculatePolicyEffectiveDate(initialDraftDate) {

  if (unavailableDraftDates.includes(getDate(initialDraftDate))){
    initialDraftDate = setDate(initialDraftDate, 28);
  }

  return format(initialDraftDate, 'MM/dd/yyyy');
}